import { Button } from '@talentmesh/ui/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { cn } from '@talentmesh/ui/lib/utils';
import { Slot } from 'radix-ui';
import { type ComponentPropsWithRef, forwardRef } from 'react';

export type TooltipIconButtonProps = ComponentPropsWithRef<typeof Button> & {
    tooltip: string;
    side?: 'top' | 'bottom' | 'left' | 'right';
};

export const TooltipIconButton = forwardRef<HTMLButtonElement, TooltipIconButtonProps>(
    ({ children, tooltip, side = 'bottom', className, ...rest }, ref) => {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant="ghost"
                        size="icon"
                        {...rest}
                        className={cn('aui-button-icon size-6 p-1', className)}
                        ref={ref}
                    >
                        <Slot.Slottable>{children}</Slot.Slottable>
                        <span className="aui-sr-only sr-only">{tooltip}</span>
                    </Button>
                </TooltipTrigger>
                <TooltipContent side={side}>{tooltip}</TooltipContent>
            </Tooltip>
        );
    },
);

TooltipIconButton.displayName = 'TooltipIconButton';
